import wrappedFetch from './base';

const fetchUserStaticIp = () => {
  return wrappedFetch('/user/static_ip.json')
    .then((response) => response.json());
};

export default fetchUserStaticIp;
